import React from 'react'
import { useTranslation } from 'react-i18next'
import { Callout, Text } from '@node-space/ui-components'
import LoginPageLayout from 'components/layout/LoginPageLayout'
import { Description } from 'components/Text'

export const EmbeddedCustomerTerms = () => {
  const { t } = useTranslation()

  return (
    <LoginPageLayout title={t('embeddedCustomerTerms.title')} narrowView={false}>
      <Description>{t('embeddedCustomerTerms.agreementsLabel')}</Description>
      <Callout>
        <Text color="inherit">{t('embeddedCustomerTerms.callout')}</Text>
      </Callout>
    </LoginPageLayout>
  )
}
